import { useFormikContext, getIn } from "formik";

/**
 * Hook that provides Formik error/touched state for a field name.
 * Safe to call outside Formik — returns no-error state.
 */
export const useFormikFieldState = (name?: string) => {
	try {
		const { errors, touched, setFieldTouched } = useFormikContext();
		if (!name)
			return {
				hasError: false,
				errorText: undefined,
				markTouched: () => {
					// purposefully empty
				},
			};

		const isTouched = !!getIn(touched, name);
		const error = getIn(errors, name);
		const errorStr = typeof error === "string" ? error : undefined;

		return {
			hasError: !!(isTouched && error),
			errorText: isTouched ? errorStr : undefined,
			markTouched: () => setFieldTouched(name, true),
		};
	} catch {
		// Not inside Formik context
		return {
			hasError: false,
			errorText: undefined,
			markTouched: () => {
				// purposefully empty
			},
		};
	}
};
